import React from 'react'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import { graphql, gql } from 'react-apollo'
import { imagePath } from 'frontend_core/dist/helpers/image'
import BusinessLayout from 'components/layouts/BusinessLayout/home'
import { viewerFragment, companyFragment } from 'fragments'

class HomeContainer extends React.Component {
  render() {
    const { data } = this.props
    const totalCount = data.totalRoomCount

    return (
      <BusinessLayout
        title={i18n.t('server.business.home.title')}
        description={i18n.t('server.business.home.description', { totalCount })}
        bodyClassName="body-home__index"
        {...this.props}
      >
        <div className="business-lp__visual">
          <div className="business-lp__visual-content container">
            <img
              src={imagePath('business/main-visual.png')}
              className="business-lp__visual-main"
            />
            <h1 className="business-lp__visual-supplement">
              スペースマーケット法人向け管理サービス
            </h1>
            <div className="business-lp__visual-title">
              社員の予約・利用・支払いを「企業・部署・チーム単位」でカンタンに管理
            </div>
            <div className="business-lp__visual-register">
              <a
                href="/signup"
                className="button-green business-lp__visual-register-button"
              >
                法人アカウント登録 (無料)
              </a>
            </div>
          </div>
        </div>
        <div className="business-lp__overview">
          <img
            src={imagePath('business/overview.png')}
            className="business-lp__overview-img"
          />
          <h2 className="business-lp__title">法人アカウントとは</h2>
          <p className="business-lp__overview-text">
            管理画面の利用や支払の一本化出来る機能です。
            <br className="sm-hide" />
            法人アカウントは企業単位だけでなく「部署やチーム」などの単位でも登録が可能です。
            <br className="sm-hide" />
            登録・ご利用ともに無料のサービスです。
          </p>
        </div>
        <div className="business-lp__pay">
          <div className="container pr">
            <div className="business-lp__pay-content">
              <img
                src={imagePath('business/merit-pay.png')}
                className="business-lp__merit-img"
              />
              <h2 className="business-lp__merit-title">経費精算が簡単に</h2>
              <p className="business-lp__merit-text">
                法人アカウントに登録された社員の
                <br className="sm-hide" />
                スペース利用をまとめて会社に請求できます。
                <br className="sm-hide" />
                社員ごとの立替が必要なくなり、経費精算がカンタンに。
              </p>
            </div>
            <img
              src={imagePath('business/pay-pc.png')}
              className="business-lp__pay-pc"
            />
          </div>
        </div>
        <div className="business-lp__reservation">
          <div className="container pr">
            <div className="business-lp__reservation-content">
              <img
                src={imagePath('business/merit-reservation.png')}
                className="business-lp__merit-img"
              />
              <h2 className="business-lp__merit-title">社員の予約を見える化</h2>
              <p className="business-lp__merit-text">
                社員の予約をリアルタイムに把握し、
                <br className="sm-hide" />
                予約一覧などを別途作成いただく必要がなく、
                <br className="sm-hide" />
                今まで以上に効率的な予約・支払管理ができます。
              </p>
            </div>
            <img
              src={imagePath('business/reservation-pc.png')}
              className="business-lp__reservation-pc"
            />
          </div>
        </div>
        <div className="business-lp__use">
          <div className="container">
            <h2 className="business-lp__title">ご利用の手順</h2>
            <div className="ta-c">
              <div className="dib">
                <div className="business-lp__use-content">
                  <img
                    src={imagePath('business/flow-create.png')}
                    className="business-lp__use-img"
                  />
                  <h3 className="business-lp__use-title">
                    法人アカウントの作成
                  </h3>
                  <p className="business-lp__use-text">
                    お持ちの個人アカウントを使い、
                    <br className="sm-hide" />
                    法人アカウントを
                    <br className="sm-hide" />
                    簡単に作成できます。
                  </p>
                </div>
                <div className="business-lp__use-content">
                  <div className="sm-hide">
                    <i className="fa fa-caret-right business-lp__use-right" />
                  </div>
                  <div className="pc-hide__sm-show">
                    <i className="fa fa-caret-down business-lp__use-right" />
                  </div>
                </div>
                <div className="business-lp__use-content">
                  <img
                    src={imagePath('business/flow-invite.png')}
                    className="business-lp__use-img"
                  />
                  <h3 className="business-lp__use-title">社員の招待</h3>
                  <p className="business-lp__use-text">
                    メールアドレスの入力及び
                    <br className="sm-hide" />
                    データの一括インポートで
                    <br className="sm-hide" />
                    社員を招待することができます。
                  </p>
                </div>
                <div className="business-lp__use-content">
                  <div className="sm-hide">
                    <i className="fa fa-caret-right business-lp__use-right" />
                  </div>
                  <div className="pc-hide__sm-show">
                    <i className="fa fa-caret-down business-lp__use-right" />
                  </div>
                </div>
                <div className="business-lp__use-content">
                  <img
                    src={imagePath('business/flow-use.png')}
                    className="business-lp__use-img"
                  />
                  <h3 className="business-lp__use-title">スペース利用</h3>
                  <p className="business-lp__use-text">
                    法人利用での予約リクエスト時に
                    <br className="sm-hide" />
                    会社宛てに支払いを
                    <br className="sm-hide" />
                    請求できるようになります。
                  </p>
                </div>
              </div>
            </div>
            <p className="clear business-lp__use-attention">
              ※ポイントは個人のアカウントに付与されます。
            </p>
          </div>
        </div>
        <div className="business-lp__use-pay">
          <div className="container">
            <h2 className="business-lp__title">お支払いについて</h2>
            <div className="ta-c">
              <div className="dib">
                <div className="business-lp__use-content business-lp__use-pay-content">
                  <img
                    src={imagePath('business/pay-bank.png')}
                    className="business-lp__use-img"
                  />
                  <h3 className="business-lp__use-title">銀行振込(後払い)</h3>
                  <p className="business-lp__use-text">
                    月末締めで翌月初旬に1ヶ月分の請求書をまとめて
                    <br className="sm-hide" />
                    お送りしますので請求書到着月末までにお支払いください。
                  </p>
                </div>
                <div className="business-lp__use-content business-lp__use-pay-content">
                  <img
                    src={imagePath('business/pay-credit.png')}
                    className="business-lp__use-img"
                  />
                  <h3 className="business-lp__use-title">クレジットカード</h3>
                  <p className="business-lp__use-text">
                    社員の予約が成立したタイミングでお支払いに選択した
                    <br className="sm-hide" />
                    カードから自動的に利用料金が決済されます。
                  </p>
                </div>
              </div>
            </div>
            <p className="business-lp__use-pay-can">
              見積書、請求書、領収書を管理者側からもダウンロードできます！
            </p>
            <p className="business-lp__use-attention">
              ※アカウント作成時は銀行振込(後払い)が設定されています。
            </p>
          </div>
        </div>
        <div className="business-lp__register">
          <h2 className="business-lp__register-text">
            社員の予約・利用・支払いを「企業・部署・チーム単位」でカンタンに管理
          </h2>
          <a
            href="/signup"
            className="business-lp__register-button-white business-lp__register-button"
          >
            法人アカウント登録 (無料)
          </a>
        </div>
      </BusinessLayout>
    )
  }
}

const withData = graphql(
  gql`
  query BusinessHomeContainer {
    totalRoomCount
    viewer {
      ${viewerFragment}
      companies(filter: MANAGED) {
        results {
          ... on Company {
            ${companyFragment}
          }
        }
      }
    }
  }
`,
  { options: { notifyOnNetworkStatusChange: true } },
)(HomeContainer)

function mapStateToProps(state) {
  return state
}

export default withRouter(connect(mapStateToProps)(withData))
